var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVariant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333313 12C0.333313 5.37258 5.7059 0 12.3333 0C18.9607 0 24.3333 5.37258 24.3333 12C24.3333 18.6274 18.9607 24 12.3333 24C5.7059 24 0.333313 18.6274 0.333313 12Z",
    fill: "#F6F6F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2333 10.6001H16.8833L14.5033 7.6251C14.2408 7.2926 13.8383 7.1001 13.4008 7.1001H8.72831C8.15081 7.1001 7.64331 7.4501 7.43331 7.9751L6.38331 10.6526C5.77081 10.8101 5.33331 11.3701 5.33331 12.0001V14.4501C5.33331 14.6426 5.49081 14.8001 5.68331 14.8001H6.73331C6.73331 15.9551 7.67831 16.9001 8.83331 16.9001C9.98831 16.9001 10.9333 15.9551 10.9333 14.8001H13.7333C13.7333 15.9551 14.6783 16.9001 15.8333 16.9001C16.9883 16.9001 17.9333 15.9551 17.9333 14.8001H18.9833C19.1758 14.8001 19.3333 14.6426 19.3333 14.4501V12.7001C19.3333 11.5451 18.3883 10.6001 17.2333 10.6001ZM8.83331 15.8501C8.25581 15.8501 7.78331 15.3776 7.78331 14.8001C7.78331 14.2226 8.25581 13.7501 8.83331 13.7501C9.41081 13.7501 9.88331 14.2226 9.88331 14.8001C9.88331 15.3776 9.41081 15.8501 8.83331 15.8501ZM10.4083 10.6001H7.88831L8.72831 8.5001H10.4083V10.6001ZM11.4583 10.6001V8.5001H13.4183L15.0983 10.6001H11.4583ZM15.8333 15.8501C15.2558 15.8501 14.7833 15.3776 14.7833 14.8001C14.7833 14.2226 15.2558 13.7501 15.8333 13.7501C16.4108 13.7501 16.8833 14.2226 16.8833 14.8001C16.8833 15.3776 16.4108 15.8501 15.8333 15.8501Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariant);
export default __webpack_public_path__ + "static/media/variant.72340e820d557c21adf53fe9513bcc63.svg";
export { ForwardRef as ReactComponent };